import { get, post, put, del } from '@api/request';

export async function processEx366(
  { appraisalService },
  authenticationToken,
  { logID },
) {
  const url = `${appraisalService}/appraisal/certificationlog/${logID}/hb366`;
  const { body } = await post(authenticationToken, url, {});
  return body;
}

export async function fetchTaxingUnitsByForm(
  { assessmentService },
  authenticationToken,
  { ptdForm, totalsRunID },
) {
  const url = `${assessmentService}/assessment/taxingunitsbyptdform/${ptdForm}?totalsRunID=${totalsRunID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEptsForms(
  { assessmentService },
  authenticationToken,
) {
  const url = `${assessmentService}/assessment/taxingunit/eptsform`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchEptsReports(
  { assessmentService },
  authenticationToken,
) {
  const url = `${assessmentService}/assessment/taxingunit/eptsreports`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPTDStateCodes({ ptdService }, authenticationToken) {
  const url = `${ptdService}/ptd/statecodes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPTDUnmappedStateCodes(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/statecode/clientstatecodenotmapped`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchClientMappings({ ptdService }, authenticationToken) {
  const url = `${ptdService}/ptd/statecode/clientmappings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addClientMapping(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/ptd/statecode/clientmappings`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updateClientMapping(
  { ptdService },
  authenticationToken,
  { stateCodeMappingID, payload },
) {
  const url = `${ptdService}/ptd/statecode/clientmapping/${stateCodeMappingID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteClientMapping(
  { ptdService },
  authenticationToken,
  { stateCodeMappingID },
) {
  const url = `${ptdService}/ptd/statecode/clientmapping/${stateCodeMappingID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPTDConfiguration(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/configuration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updatePTDConfiguration(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/ptd/configuration`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchPTDSULandTypes({ ptdService }, authenticationToken) {
  const url = `${ptdService}/ptd/ptdsulandtypes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function importPTDSULandTypes(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/ptdsulandtypeimport`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchPTDUnmappedSULandTypes(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/landtypenotmapped`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPTDLandTypeMappings(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/landtypemappings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPTDLandTypeMapping(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/ptd/landtypemappings`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePTDLandTypeMapping(
  { ptdService },
  authenticationToken,
  { payload, landTypeID },
) {
  const url = `${ptdService}/ptd/landtypemapping/${landTypeID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deletePTDLandTypeMapping(
  { ptdService },
  authenticationToken,
  { landTypeID },
) {
  const url = `${ptdService}/ptd/landtypemapping/${landTypeID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPTDExemptions({ ptdService }, authenticationToken) {
  const url = `${ptdService}/ptd/ptdexemptionlisting`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function importPTDExemptions({ ptdService }, authenticationToken) {
  const url = `${ptdService}/ptd/ptdexemptionimport`;
  const { body } = await post(authenticationToken, url);
  return body;
}

export async function fetchPTDUnmappedExemptions(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/exemptionnotmapped`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPTDExemptionMappings(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/ptd/exemptionmappings`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertPTDExemptionMapping(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/ptd/exemptionmappings`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function updatePTDExemptionMapping(
  { ptdService },
  authenticationToken,
  { payload, exemptionID },
) {
  const url = `${ptdService}/ptd/exemptionmapping/${exemptionID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deletePTDExemptionMapping(
  { ptdService },
  authenticationToken,
  { exemptionID },
) {
  const url = `${ptdService}/ptd/exemptionmapping/${exemptionID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchPVSTaxRateSubmissions(
  { ptdService },
  authenticationToken,
) {
  const url = `${ptdService}/certification/pvstaxratesubmissions`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createPVSTaxRateSubmission(
  { ptdService },
  authenticationToken,
  { payload },
) {
  const url = `${ptdService}/certification/pvstaxratesubmissions`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function getExportRunTaxingUnits(
  { ptdService },
  authenticationToken,
  { totalsRunID },
) {
  const url = `${ptdService}/assessment/taxingunitsbyptdform/50-897?totalsRunID=${totalsRunID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function launchExportRun(
  { ptdService },
  authenticationToken,
  { payload, totalsRunID },
) {
  const url = `${ptdService}/ptd/totals/${totalsRunID}/export_50_897`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function getExportRunHistory(
  { ptdService },
  authenticationToken,
  { totalsRunID },
) {
  const url = `${ptdService}/ptd/totals/${totalsRunID}/export_50_897`;
  const { body } = await get(authenticationToken, url);
  return body;
}
